'use client';

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import { PrismicNextImage } from '@prismicio/next';
import clsx from 'clsx';
import React, { useMemo } from 'react';
import { CryptoTableType } from '@/utils/types';
const FeesBody = t0 => {
  const $ = _c(9);
  const {
    variant,
    rows,
    feesRow
  } = t0;
  let t1;
  if ($[0] !== feesRow || $[1] !== rows || $[2] !== variant) {
    t1 = variant == "buyFeesAndLimits" ? rows?.map(item => {
      const extra_coin = item.coin_extras?.find(coin => coin.service_name == feesRow);
      const transaction_limit = `${extra_coin?.min_transaction_limit} - ${extra_coin?.max_transaction_limit}`;
      return [item.buyValue, item.buyFeeFlat, transaction_limit, extra_coin?.daily_limit];
    }) || [] : rows?.map(item_0 => {
      const extra_coin_0 = item_0.coin_extras?.find(coin_0 => coin_0.service_name == feesRow);
      const transaction_limit_0 = `${extra_coin_0?.min_transaction_limit} - ${extra_coin_0?.max_transaction_limit}`;
      return [item_0.sellValue, transaction_limit_0, extra_coin_0?.daily_limit];
    }) || [];
    $[0] = feesRow;
    $[1] = rows;
    $[2] = variant;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const centerRows = t1;
  let t2;
  if ($[4] !== centerRows || $[5] !== rows) {
    t2 = rows?.map((row, rowIndex) => <tr className="child:h-[inherit] child:p-0 first:child:child:border-t-0 first:child:border-t child:first:border-l child:first:pl-6 last:child:border-b child:last:border-r child:last:pr-6 h-18 border-gray-200" key={row.ticker}><td><div className="flex h-full items-center gap-x-3 border-t"><PrismicNextImage fallbackAlt="" width={28} height={28} field={row.icon} />{`${row.label} (${row.ticker}/${row.currencyCode})`}</div></td>{centerRows[rowIndex]?.map((item_1, itemIndex) => <td key={item_1}><div className={clsx("flex h-full items-center border-t", {
          "justify-end": itemIndex === centerRows[rowIndex].length - 1
        })}>{item_1}</div></td>)}</tr>);
    $[4] = centerRows;
    $[5] = rows;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <tbody className="shadow-elevation-3 before:block before:h-4" data-sentry-component="FeesBody" data-sentry-source-file="index.tsx">{t2}</tbody>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
export default FeesBody;